import { reactive } from 'vue'

// Single source of truth for the tenant selected in the untenanted admin console.
// The /tenants API returns tenants name-ASC, so tenants[0] is first alphabetically.
const STORAGE_KEY = 'selectedTenant'

export const tenantStore = reactive({
  tenants: [],
  selected: null, // tenant code, e.g. 'otk'

  setTenants(list) {
    this.tenants = Array.isArray(list) ? list : []
    const codes = this.tenants.map(t => t.code)
    let cached = null
    try { cached = localStorage.getItem(STORAGE_KEY) } catch (_) { /* ignore */ }
    this.selected = (cached && codes.includes(cached)) ? cached : (this.tenants[0]?.code ?? null)
  },

  select(code) {
    this.selected = code
    try { localStorage.setItem(STORAGE_KEY, code) } catch (_) { /* ignore */ }
  },

  get current() {
    return this.tenants.find(t => t.code === this.selected) ?? null
  },
})
